import { Route } from '@angular/router';
import { authGuard } from '@copilot/shared';
import { Home } from '../components/home/home';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: Home, data: { hideHeader: true } },
  { path: 'auth', loadChildren: () => import('@copilot/auth').then(m => m.authRoutes) },
  { path: 'admin', loadChildren: () => import('@copilot/admin').then(m => m.adminRoutes), canActivate: [authGuard] },
  { path: 'org', loadChildren: () => import('@copilot/organization').then(m => m.organizationRoutes), canActivate: [authGuard] },
  { path: 'inbox', loadChildren: () => import ('@copilot/inbox').then(m => m.inboxRoutes), canActivate: [authGuard] }
];
